import cloneDeep from 'lodash/cloneDeep';
import { freezeSys, toPlainObject } from 'contentful-sdk-core';
import enhanceWithMethods from '../enhance-with-methods';
import errorHandler from '../error-handler';
function createEditorInterfaceApi(http) {
  return {
    update: function update() {
      var self = this;
      var raw = self.toPlainObject();
      var data = cloneDeep(raw);
      delete data.sys;
      return http.put("content_types/".concat(self.sys.contentType.sys.id, "/editor_interface"), data, {
        headers: {
          'X-Contentful-Version': self.sys.version
        }
      }).then(function (response) {
        return wrapEditorInterface(http, response.data);
      }, errorHandler);
    },
    getControlForField: function getControlForField(fieldId) {
      var self = this;
      var result = self.controls.filter(function (control) {
        return control.fieldId === fieldId;
      });
      return result && result.length > 0 ? result[0] : null;
    }
  };
}
/**
 * @private
 */

export function wrapEditorInterface(http, data) {
  var editorInterface = toPlainObject(cloneDeep(data));
  var editorInterfaceWithMethods = enhanceWithMethods(editorInterface, createEditorInterfaceApi(http));
  return freezeSys(editorInterfaceWithMethods);
}